import { Typography } from "@mui/material";
import { sxTypographyAdvice, sxTypographyAdviceTitle } from "./sxProps";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/pro-regular-svg-icons";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";

const AdviceContainer: React.FC = () => {

    const accessibility = useAccessibility();

    return (
        <div className='advice-container' style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}}>
            <div className='advice-icon-holder'>
                <FontAwesomeIcon icon={faTriangleExclamation} className='far-triangle-exclamation'/>
            </div>
            <div className='advice-text'>
                <Typography style={accessibility.textStyleAccessibility} sx={sxTypographyAdviceTitle}>ATENÇÃO: </Typography>
                <Typography style={accessibility.textStyleAccessibility} sx={sxTypographyAdvice}>Sua consulta, ainda que confirmada, poderá atrasar ou ser cancelada em casos de força maior. Se isso ocorrer, entraremos em contato.</Typography>
            </div>
        </div>
    )
}

export default AdviceContainer;